<template>
  <div>
    <div class="inhouse-cookie-consent container" :class="{'is-active': cookieActive}">
      <div class="inhouse-cookie-consent__header">
        <h5>Our website, provided by Bionic uses cookies</h5>
        <p>
          Some cookies are required to run our website to keep it secure, and
          obey regulations that apply to us. Others you can opt out of.
          <a
            href="https://bionic.co.uk/about-bionic/privacy/"
            target="_blank"
            rel="noopener"
          >Privacy policy</a>
        </p>
        <img
          :src="require(`@mic/frontend/assets/logos/provided-by-logo.svg`)"
          alt="Provided by Bionic"
          class="inhouse-cookie-consent__logo"
        >
      </div>
      <div class="inhouse-cookie-consent__body">
        <div class="inhouse-cookie-consent__row">
          <p>Always on</p>
          <div class="inhouse-cookie-consent__row-inner">
            <div>
              <h6>Strictly Necessary</h6>
              <a
                href="#"
                class="inhouse-cookie-consent__trigger"
                data-target="necessary"
                :class="{'is-active': necessary.accordion}"
                @click="toggleAccordion('necessary')"
              >Show details</a>
            </div>
            <p id="necessary" class="inhouse-cookie-consent__content" :class="{'is-active': necessary.accordion}">
              These cookies are essential in order to enable you to move around
              the website and use its features, such as accessing secure areas
              of the website. Without these, we cannot guarantee that you will
              be able to use our websites
            </p>
          </div>
        </div>
        <div class="inhouse-cookie-consent__row">
          <div class="toggle">
            <label>
              <input id="inhouse-cookie-consent-checkbox" v-model="cookies" value="performance" type="checkbox">
              <span class="toggle__trigger" :class="{'is-active': cookies.includes('performance')}"> {{ cookies.includes('performance') ? 'on' : 'off' }} </span>
            </label>
          </div>

          <div class="inhouse-cookie-consent__row-inner">
            <div>
              <h6>Performance</h6>
              <a
                href="#"
                class="inhouse-cookie-consent__trigger"
                :class="{'is-active': performance.accordion}"
                @click="toggleAccordion('performance')"
              >Show details</a>
            </div>
            <p id="performance" class="inhouse-cookie-consent__content" :class="{'is-active': performance.accordion}">
              These cookies tell us how customers use our website. This data
              helps us understand how our products are being used and what we
              can do to improve their performance. All data is aggregated and
              anonymous.
            </p>
          </div>
        </div>
      </div>
      <div class="inhouse-cookie-consent__footer">
        <a
          href="https://bionic.co.uk/about-bionic/privacy/"
          target="_blank"
          rel="noopener"
        >Privacy policy</a>

        <div class="inhouse-cookie-consent__footer-cta">
          <button id="inhouse-cookie-consent-save" @click="saveCookies">
            Save and continue
          </button>
          <button id="inhouse-cookie-consent-accept" @click="acceptAll">
            Accept all and continue
          </button>
        </div>
      </div>
    </div>
    <div class="cookie-mask" />
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'CookieConsent',
  data () {
    return {
      cookieActive: false,
      performance: {
        accordion: false
      },
      necessary: {
        accordion: false
      },
      cookies: []
    }
  },
  mounted () {
    if (!Cookies.get('cookie_consent')) {
      this.cookieActive = true
    }
  },
  methods: {
    toggleAccordion (target) {
      if (this[target].accordion) {
        this[target].accordion = false
      } else {
        this[target].accordion = true
      }
    },
    saveCookies () {
      this.cookies.forEach(cookie => {
        // differentiate cookies
        Cookies.set('cookie_consent', true, { expires: 365 })
      })
      this.cookieActive = false
      this.$emit('close-cookie-wall')
    },
    acceptAll () {
      Cookies.set('cookie_consent', true, { expires: 365 })
      this.cookieActive = false
      this.$emit('close-cookie-wall')
    }
  }
}
</script>

<style lang="scss" scoped>

.btn-mic-primary {
  padding: 15px 30px;
  border-radius: 28px;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: $button-text !important;
  background: $button-bg;
  cursor: pointer;
}

.modal-backdrop {
  background-color: $text-color !important;
}

.modal-backdrop.show {
  opacity: 0.8 !important;
}

.modal-content {
  height: auto;
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.12);
}

.inhouse-cookie-consent {
  text-align: left;
  position: fixed;
  visibility: hidden;
  bottom: -100%;
  left: 50%;
  width: 100%;
  transform: translateX(-50%);
  z-index: 1050;
  padding: 16px;
  background: rgba(#10265c, 0.95);
  color: $white;
  transition: bottom 0.65s $ease-out, visibility 0.65s $ease-out;

  @media (min-width: $screen-sm) {
    padding: 30px;
  }

  &.is-active {
    bottom: 0;
    overflow-y: auto;
    max-height: 100vh;
    visibility: visible;
  }

  a {
    color: $white;
    text-decoration: underline;
  }

  h5 {
    @media (max-width: $screen-sm) {
      padding-right: 70px;
    }
  }

  &__header {
    position: relative;

    @media (min-width: $screen-sm) {
      padding-right: 110px;
    }

    p {
      font-size: 12px;
      line-height: 18px;

      @media (min-width: $screen-sm) {
        font-size: 14px;
        line-height: 20px;
      }

      @media (min-width: $screen-md) {
        font-size: 16px;
        line-height: 22px;
      }
    }

    a {
      @media (min-width: $screen-md) {
        display: none;
      }
    }
  }

  &__logo {
    position: absolute;
    top: 0;
    right: 0;
    width: 55px;
    height: auto;

    @media (min-width: $screen-sm) {
      width: 85px;
    }
  }

  &__body,
  &__footer {
    margin-top: 24px;
  }

  &__row {
    display: flex;

    @media (max-width: $screen-md) {
      flex-direction: row-reverse;
    }

    > p {
      white-space: nowrap;
      line-height: 1.1;
      margin-bottom: 0;
      min-width: 80px;
    }

    .toggle {
      min-width: 80px;
    }

    > p,
    .toggle {
      @media (max-width: $screen-md) {
        position: absolute;
        right: 16px;
      }
    }

    &-inner {
      width: 100%;
      margin-right: 16px;

      @media (min-width: $screen-lg) {
        margin-left: 16px;
        margin-right: 0;
      }

      > div {
        @media (min-width: $screen-md) {
          display: flex;
          align-items: baseline;
        }
      }
    }

    & + .inhouse-cookie-consent__row {
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px solid $white;
    }
  }

  &__trigger {
    display: flex;
    align-items: center;

    @media (min-width: $screen-md) {
      margin-left: 12px;
    }

    &::after {
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid $white;
      content: '';
      display: block;
      margin-left: 6px;
    }

    &[data-target='necessary'] {
      @media (min-width: $screen-md) {
        display: none;
      }
    }

    &.is-active::after {
      transform: rotate(180deg);
    }
  }

  #necessary {
    @media (min-width: $screen-md) {
      display: block;
    }
  }

  &__content {
    display: none;
    margin-bottom: 0;

    &.is-active {
      display: block;
    }
  }

  #inhouse-cookie-consent-accept {
    @extend .btn-mic-primary;
    border-radius: 4px;
  }

  #inhouse-cookie-consent-save {
    @extend .btn-mic-primary;
    border-radius: 4px;
    border: 1px solid $white;
    background: transparent;
  }

  &__footer {
    display: flex;

    @media (min-width: $screen-md) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    &-cta {
      @media (max-width: $screen-sm) {
        display: flex;
        flex-direction: column-reverse;
        width: 100%;
      }
    }

    a {
      @media (max-width: $screen-sm) {
        display: none;
      }
    }

    button {
      width: 100%;

      @media (min-width: $screen-md) {
        width: auto;
      }

      & + button {
        margin-bottom: 12px;

        @media (min-width: $screen-md) {
          margin-bottom: 0;
          margin-left: 12px;
        }
      }
    }
  }
}

.cookie-mask {
  @extend .modal-backdrop;

  #app.modal-open & {
    opacity: 0.7 !important;
    visibility: visible;
    width: 100%;
    height: 100%;
    z-index: 1010;
    position: absolute;
    top: 0;
}

  visibility: hidden;
  background: $black !important;
  opacity: 0;
  transition: opacity 0.2s $ease-out, visibility 0.2s $ease-out;

}

.toggle {
  position: relative;

  input {
    width: 0;
    height: 0;
    opacity: 0;
  }

  label {
    padding-left: 75px;
    cursor: pointer;
  }

  &__trigger {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 58px;
    height: 26px;
    border-radius: 50px;
    background-color: #d8d8d8;
    transition: 0.2s;

    color: $black;
    text-align: right;
    padding: 3px 10px;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 20px;

    // IE11
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      line-height: 26px;
    }

    &::before {
      position: absolute;
      left: 3px;
      top: 3px;
      height: 20px;
      width: 20px;
      border-radius: 50%;

      background-color: $white;
      transition: 0.2s;
      content: '';
    }

    &.is-active {
      background-color: $valid;
      color: $white;
      text-align: left;

      &::before {
        transform: translateX(32px);
      }

      p {
        left: 10px;
        right: auto;
        color: $white;
      }
    }
  }
}

</style>
